import { render, staticRenderFns } from "./QualificationsHonors.vue?vue&type=template&id=f6b4fdac&scoped=true"
import script from "./QualificationsHonors.vue?vue&type=script&lang=js"
export * from "./QualificationsHonors.vue?vue&type=script&lang=js"
import style0 from "./QualificationsHonors.vue?vue&type=style&index=0&id=f6b4fdac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6b4fdac",
  null
  
)

export default component.exports